'use client';

import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

import { useLayout } from '@/context/layout-context';
import { Paths } from '@/utils/paths';

import { AccountMenu } from './AccountMenu';
import { NavLink } from './NavLink';
import { SolutionsMenu } from './SolutionsMenu';

export type MenuProps = ComponentProps<'nav'>;

export function Menu({ className, ...props }: MenuProps) {
  const { content } = useLayout();

  const { giftcard, zmyle, contact } = content.topbar;

  return (
    <nav
      className={twMerge('flex items-center gap-8 text-base', className)}
      {...props}
    >
      <NavLink href={Paths.SEARCH}>{giftcard}</NavLink>

      <SolutionsMenu content={content} />

      <NavLink href={Paths.ZMYLE}>{zmyle}</NavLink>

      <NavLink href={Paths.CONTACT}>{contact}</NavLink>

      <AccountMenu content={content} />
    </nav>
  );
}
